import { ServiceResponse } from '@sdbn/appclient';

export class Station {

  id: number;
  name: string;
  identifier: string;
  isWaitingArea: boolean;
  // tmp variablen für d+d
  grabOffsetX: number;
  grabOffsetY: number;

  constructor(station: any) {
    this.id = station.id;
    this.name = station.name;
    this.identifier = station.identifier;
    this.isWaitingArea = station.isWaitingArea;
  }
}

export class StationAssignment {

  deleted: boolean;
  id: number;
  stationId: number;
  name: string;
  identifier: string;
  x: number;
  y: number;
  color: string;
  fontColor: string;
  legendEntryId: number;
  isWaitingArea: boolean;

  // tmp variablen für d+d
  grabOffsetX: number;
  grabOffsetY: number;

  selected: boolean;

  constructor(assignment: any) {
    this.id = assignment.id;
    this.stationId = assignment.stationId;
    this.name = assignment.name;
    this.identifier = assignment.identifier;
    this.x = assignment.x;
    this.y = assignment.y;
    this.color = assignment.color;
    this.fontColor = assignment.fontColor;
    this.legendEntryId = assignment.legendEntryId;
    this.isWaitingArea = assignment.isWaitingArea;
  }
}

export enum LegendPosition {
  TOP = 'TOP', LEFT = 'LEFT', BOTTOM = 'BOTTOM', RIGHT = 'RIGHT'
}

export class MapConfiguration {
  id: number;
  name: string;

  constructor(configuration: any) {
    this.id = configuration.id;
    this.name = configuration.name;
  }

}

export class MapConfigurationDetails {

  dirty: boolean;
  invalid: boolean;

  id: number;
  name: string;
  mapResourceUUID: string;
  mapURL: string;
  width: number;
  height: number;
  legendPosition = LegendPosition.BOTTOM;

  // drag and drop
  draggedStation: Station;
  draggedStationAssignment: StationAssignment;
  draggedLegendEntry: LegendEntry;

  // selection
  selectedStationAssignment: StationAssignment;
  editableLegendEntry: LegendEntry;

  stationAssignments = new Array<StationAssignment>();
  legendEntries = new Array<LegendEntry>();
}

export class LegendEntry {

  deleted: boolean;
  id: number;
  name: string;
  color: string;
  fontColor: string;

  constructor(entry: any) {
    this.id = entry.id;
    this.name = entry.name;
    this.color = entry.color;
    this.fontColor = entry.fontColor || '#000000';
  }
}

// DTOs for save action
export class SaveMapConfiguration {

  id: number;
  name: string;
  mapResourceUUID: string;
  width: number;
  height: number;
  legendPosition = LegendPosition.BOTTOM;

  stationAssignments = new Array<SaveStationAssignment>();
  legendEntries = new Array<SaveLegendEntry>();
}

export class SaveStationAssignment {
  deleted: boolean;
  id: number;
  stationId: number;
  legendEntryId: number;
  x: number;
  y: number;
}

export class SaveLegendEntry {
  deleted: boolean;
  id: number;
  name: string;
  color: string;
  fontColor: string;
  sortIndex: number;
}

export class SaveMapConfigurationResponse {
  mapConfigurationId: number;
}

// END DTOs for save action

export class UploadMapFileServiceResponse extends ServiceResponse {
  mapResourceUUID: string;
}
